import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem2VLSI1 = () => {
  const data = [
    {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2025-Batch/EVE-1-2-Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">VLSI Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2VLSI1